export default {
  desktop: 1280,
  tablet: 920,
  mobile: 768,
  phablet: 660,
  mobileSe: 410,
  mainMenu: 980,
  mainMenuContactButton: 610,
};
